// shared.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageComponent } from './language.component';
import { LanguageSelectComponent } from './languageSelector.component';
import { CapitalizePipe, LangServicePipe } from './lang-service.pipe';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [LanguageComponent, LanguageSelectComponent, LangServicePipe, CapitalizePipe],
  imports: [CommonModule, FormsModule],
  exports: [LanguageComponent, LanguageSelectComponent, LangServicePipe, CapitalizePipe],
})
export class LanguageModule {}